import * as Url from './url.js';
export var MimetypesKind = {
    opus: 'video/ogg',
    ogv: 'video/ogg',
    mp4: 'video/mp4',
    mov: 'video/mp4',
    m4v: 'video/mp4',
    mkv: 'video/x-matroska',
    flv: 'video/flv',
    mp3: 'audio/mpeg',
    aac: 'audio/aac',
    oga: 'audio/ogg',
    m4a: 'audio/mp4',
    m3u8: 'application/x-mpegURL',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    png: 'image/png',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
export var getMimetype = function getMimetype() {
    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var ext = Url.getFileExtension(src);
    var mimetype = MimetypesKind[ext.toLowerCase()];
    return mimetype || '';
};
export var findMimetype = function findMimetype(player, src) {
    if (!src) {
        return '';
    }
    if (player.cache_.source.src === src && player.cache_.source.type) {
        return player.cache_.source.type;
    }
    var matchingSources = player.cache_.sources.filter(function (s) {
        return s.src === src;
    });
    if (matchingSources.length) {
        return matchingSources[0].type;
    }
    var sources = player.$$('source');
    for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        if (s.type && s.src && s.src === src) {
            return s.type;
        }
    }
    return getMimetype(src);
};